import { NgxLoggerLevel } from 'ngx-logger';

import { environmentCommon } from './environment-common';
import { AppEnvironment } from './types';

// This environment file is kept for:
// 1. Build-time configuration (logs, production flag)
// 2. Tests that still reference environment.apiBaseUrl
//
// Runtime configuration (apiBaseUrl, eid, googlePlacesApiKey) is loaded from /assets/config.json
// See AppConfigService for runtime configuration

export const environment: AppEnvironment = {
  ...environmentCommon,
  production: true,
  // Production build: silence only the noisiest levels (TRACE/DEBUG); keep INFO/LOG/WARN/ERROR/FATAL.
  // ngx-logger gates the Faro monitor on this same level (shouldCallMonitor => level >= config.level),
  // so anything below this threshold never reaches Faro. Keep it at INFO so informational app logs
  // (logger.log/info) are forwarded to observability, not just warnings and errors.
  logs: {
    logger: {
      ...environmentCommon.logs.logger,
      level: NgxLoggerLevel.INFO,
    },
  },
};
